import React from "react";

/**
 * Reusable heading + description block with light default styling.
 * Inline styles keep it simple; callers can override via style props.
 */
const HeadingWithDescription = ({
  heading,
  description,
  containerStyle = {},
  headingStyle = {},
  descriptionStyle = {},
}) => {
  const mergedContainerStyle = {
    // marginBottom: "20px",
    marginTop: "10px",
    paddingLeft: "20px",
    ...containerStyle,
  };

  const mergedHeadingStyle = {
    margin: "0",
    fontSize: "1.2rem",
    color: "#3b3b3b",
    fontWeight: 600,
    ...headingStyle,
  };

  const mergedDescriptionStyle = {
    margin: 0,
    color: "#666",
    fontSize: "0.80rem",
    ...descriptionStyle,
  };

  return (
    <div style={mergedContainerStyle}>
      <h2 style={mergedHeadingStyle}>{heading}</h2>
      <p style={mergedDescriptionStyle}>{description}</p>
    </div>
  );
};

export default HeadingWithDescription;

